export default __webpack_public_path__ + "static/media/CME.ebfe045a.svg";